import { createContext } from '@lit/context';
export const walletAccountContext = createContext(Symbol('wallet account context'));
//# sourceMappingURL=context.js.map